import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AdministrativeDivisionService } from '../../../service/administrative-division/administrative-division.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectAdministrativeDivisionComponent),
  multi: true,
};

@Component({
  selector: 'app-select-administrative-division',
  templateUrl: './select-administrative-division.component.html',
  styleUrls: ['./select-administrative-division.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectAdministrativeDivisionComponent implements ControlValueAccessor,OnChanges {
    @Input() administrativeDivisionId: number;
    @Input() countryId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public administrativeDivisionsOptions: any[];
    public outputObject: any;

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public administrativeDivisionService: AdministrativeDivisionService
    ) {
        this.page = 1;
        this.per_page = 50;
        this.query = undefined;
        this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        //this.getAdministrativeDivisions(this.query, this.filters);
    }
    ngOnInit() {
        // this.getAdministrativeDivisions(this.query, this.filters);
    }
    ngOnChanges(){
        if(this.countryId) {
            this.filters = [];
            this.filters.push({key: 'country_id', value: String(this.countryId)});
            this.getAdministrativeDivisions(this.query, this.filters);//this.ngOnInit();
        }
    }
    writeValue(value: any) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    public change($event) {
        this.outputObject = this.administrativeDivisionsOptions.find((item) => item.id == $event.target.value);
        this.emitOutput(this.outputObject);
    }

    getAdministrativeDivisions(query?: string, filters?: any[]) {
        this.administrativeDivisionService.getAdministrativeDivision(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                var administrativeDivisions = response.json().data;
                var statusFind= false;
                this.administrativeDivisionsOptions = [];
                administrativeDivisions = this.sortData(administrativeDivisions, 'asc');
                if(response.json().meta.total_filtered == "0"){
                    this.emitOutput(undefined);
                    this.administrativeDivisionsOptions.push({id: undefined, name: 'choose', selected: true, code_sorttime: undefined});
                }
                    
                else
                    this.administrativeDivisionsOptions.push({id: undefined, name: 'choose', code_sorttime: undefined});    
                administrativeDivisions.forEach(element => {
                    if (this.administrativeDivisionId == element.id) {
                        this.administrativeDivisionsOptions.push({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                        this.emitOutput({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                        statusFind= true;
                    } 
                    else {
                        this.administrativeDivisionsOptions.push({id: element.id, name: element.name, selected: false, code_sorttime: element.code_sorttime});
                    }
                });
                if(statusFind == false)
                    this.emitOutput(undefined);
                
            },
            error => {
                this.administrativeDivisionsOptions = [];
                this.administrativeDivisionsOptions.push({id: '', name: 'Error'});
            }
        );
    }
    public emitOutput(value: any) {   
        this.onMyChange.emit(value);
        this.onChange(value);//this.onChange = "";//
        this.onTouched(value);//this.onTouched = ""; //
    }
    public sortData(data, type) {
        let ordered = [];
        let dataArr = [].slice.call(data);
        let dataSorted = dataArr.sort((a, b) => {
            if (type === "asc") {
                if (a.name < b.name) return -1
                else return 1
            } else {
                if (a.name > b.name) return -1
                else return 1
            }
        });
        dataSorted.forEach(e => {
            var words = e.name.split(" ");
            for(var i = 0; i < words.length; i++){
                words[i] = words[i].toLowerCase();
                if(words[i] != "y" && words[i] != "de")
                    words[i] = this.capitalize(words[i]);
            }
            e.name = words.join(" ");
            ordered.push(e);
        });
        return ordered;
    }

    public capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }
    
    public lowerCase(word){
        const palabras = word.toLowerCase();
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/administrative-division/select-administrative-division/select-administrative-division.component.ts